export const AI_USAGE_RESULTS_PATH = '/api/ai-usage/results'

export const AI_USAGE_RESOURCE_TYPE = Object.freeze({ PRESENTATION: 'presentation' })

export const OPEN_AI_USAGE_MESSAGE = 'open-ai-usage'
export const AI_USAGE_STATE_MESSAGE = 'ai-usage-state'

export const AI_USAGE_WINDOW_PATH = '/ai-usage'

export const AI_USAGE_SCOPE = Object.freeze({ ME: 'me', TEAM: 'team' })

export const AI_USAGE_SOURCE = Object.freeze({
  PRESENTER_IMPORT: 'presenter-import',
  PRESENTATION_PROMPT: 'presentation-prompt',
})
